import axios from "axios";
import { useEffect, useMemo, useState, useCallback } from "react";
import { BACKEND } from "../config/configEnvs";
import { toast } from "react-toastify";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import Selector from "../components/ui/components/Selector";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
// import InputFormValue from "../components/ui/components/InputFormValue";
import EditButton from "../components/ui/components/EditButton";
// import DeleteButton from "../components/ui/components/DeleteButton";
// import MainSaveButton from "../components/ui/components/MainSaveButton";
// import PaginationItem from "../components/ui/components/Pagination";
import InputRowValue from "../components/ui/components/InputRowValue";
import DinamicBoxButton from "../components/ui/components/DinamicBoxButton";
import { FaSave, FaTimes } from "react-icons/fa";
import ParseNumberToFloat from "../utils/helpers/ParseNumberToFloat";

const ReglasComisiones = () => {

  const [loading, setLoading] = useState(false);

  // const [limit, setLimit] = useState(20);
  // const [page, setPage] = useState(1);
  
  const [comissionRules, setComissionRules] = useState([]);
  const [categorySelected, setCategorySelected] = useState("");

  // const [totalDocs, setTotalDocs] = useState(0);
  // const [totalPages, setTotalPages] = useState(1);

  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});

  // const [creating, setCreating] = useState(false);
  // const [newRule, setNewRule] = useState({
  //   name: "",
  //   category: "",
  //   months: "",
  //   plan: "",
  //   rangeMin: "",
  //   rangeMax: "",
  //   percentage: "",
  //   fixedGoal: "",
  //   fixedCommission: "",
  //   validFrom: "",
  //   validTo: "",
  // });

  const categoryOptions = useMemo(() => ([
    { label: "ADS", value: "ADS" },
    { label: "Web", value: "Web" },
    { label: "Software", value: "Software" },
    { label: "Individual", value: "Individual" },
  ]), []);

  const monthsOptions = useMemo(() => ([
    { label: "", value: "" },
    { label: "1", value: "1" },
    { label: "3", value: "3" },
    { label: "6", value: "6" },
    { label: "12", value: "12" },
  ]), []);

  const planOptions = useMemo(() => ([
    { label: "", value: "" },
    { label: "Pro", value: "Pro" },
    { label: "Premium", value: "Premium" },
  ]), []);

  const parseNumberOrNull = (val) => {
    if (val === null || val === undefined || val === "") return null;
    const num = Number(val);
    return Number.isNaN(num) ? null : num;
  }

  const startEdit = (rule) => {
    const id = rule.id || rule._id;
    setEditingId(id);
    setEditForm({
      name: rule.name || "",
      category: rule.category || "",
      months: rule.months || "",
      plan: rule.plan || "",
      rangeMin: rule.rangeMin ?? "",
      rangeMax: rule.rangeMax ?? "",
      percentage: rule.percentage ?? "",
      fixedGoal: rule.fixedGoal ?? "",
      fixedCommission: rule.fixedCommission ?? "",
      validFrom: rule.validFrom ? String(rule.validFrom).slice(0,10) : "",
      validTo: rule.validTo ? String(rule.validTo).slice(0,10) : "",
    });
  }

  const cancelEdit = () => {
    setEditingId(null);
    setEditForm({});
  }

  const saveEdit = async () => {
    try {
      if (!editingId) return;
      const payload = {
        name: editForm.name,
        category: editForm.category,
        months: editForm.months || null,
        plan: editForm.plan || null,
        rangeMin: parseNumberOrNull(editForm.rangeMin),
        rangeMax: parseNumberOrNull(editForm.rangeMax),
        percentage: parseNumberOrNull(editForm.percentage),
        fixedGoal: parseNumberOrNull(editForm.fixedGoal),
        fixedCommission: parseNumberOrNull(editForm.fixedCommission),
        validFrom: editForm.validFrom || null,
        validTo: editForm.validTo || null,
      };
      if (payload.percentage != null && (payload.percentage < 0 || payload.percentage > 100)) {
        toast.error("El porcentaje debe estar entre 0 y 100");
        return;
      }
      const { data } = await axios.patch(`${BACKEND}/api/reglasComisiones/${editingId}`, payload);
      const updated = data?.doc || data;
      setComissionRules(prev => prev.map(r => ((r.id || r._id) === editingId) ? { ...r, ...updated } : r));
      toast.success("Regla actualizada");
      cancelEdit();
    } catch (error) {
      console.log(error);
      toast.error("Error al actualizar la regla");
    }
  }

  // const deleteRule = async (rule) => {
  //   try {
  //     const id = rule.id || rule._id;
  //     const ok = window.confirm(`¿Eliminar la regla "${rule.name}"?`);
  //     if (!ok) return;
  //     await axios.delete(`${BACKEND}/api/reglasComisiones/${id}`);
  //     setComissionRules(prev => prev.filter(r => (r.id || r._id) !== id));
  //     toast.success("Regla eliminada");
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("Error al eliminar la regla");
  //   }
  // }

  // const createRule = async () => {
  //   try {
  //     setCreating(true);
  //     if (!newRule.name || !newRule.category) {
  //       toast.error("Nombre y categoría son obligatorios");
  //       return;
  //     }
  //     const payload = {
  //       name: newRule.name,
  //       category: newRule.category,
  //       months: newRule.months || null,
  //       plan: newRule.plan || null,
  //       rangeMin: parseNumberOrNull(newRule.rangeMin),
  //       rangeMax: parseNumberOrNull(newRule.rangeMax),
  //       percentage: parseNumberOrNull(newRule.percentage),
  //       fixedGoal: parseNumberOrNull(newRule.fixedGoal),
  //       fixedCommission: parseNumberOrNull(newRule.fixedCommission),
  //       validFrom: newRule.validFrom || null,
  //       validTo: newRule.validTo || null,
  //     };
  //     if (payload.percentage != null && (payload.percentage < 0 || payload.percentage > 100)) {
  //       toast.error("El porcentaje debe estar entre 0 y 100");
  //       return;
  //     }
  //     const { data } = await axios.post(`${BACKEND}/api/reglasComisiones`, payload);
  //     const created = data?.doc || data;
  //     setComissionRules(prev => [created, ...prev]);
  //     setNewRule({
  //       name: "",
  //       category: "",
  //       months: "",
  //       plan: "",
  //       rangeMin: "",
  //       rangeMax: "",
  //       percentage: "",
  //       fixedGoal: "",
  //       fixedCommission: "",
  //       validFrom: "",
  //       validTo: "",
  //     });
  //     toast.success("Regla creada");
  //   } catch (error) {
  //     console.log(error);
  //     toast.error("Error al crear la regla");
  //   } finally {
  //     setCreating(false);
  //   }
  // }

  const getComissionRules = useCallback(async () => {
    try {
      setLoading(true);
      let url = `${BACKEND}/api/reglasComisiones?limit=0`;

      if (categorySelected) {
        url += `&where[category][equals]=${categorySelected}`;
      }
      
      const response = await axios.get(`${url}`);
      setComissionRules(response.data?.docs || []);
      // setTotalDocs(response.data?.totalDocs || 0);
      // setTotalPages(response.data?.totalPages || 1);
    } catch (error) {
      console.log(error);
      toast.error("Error al obtener las reglas de comisiones");
    } finally {
      setLoading(false);
    }
  }, [categorySelected]);

  useEffect(() => {
    getComissionRules();
  }, [getComissionRules]);

  const individualCols = [
    { width: "w-[15rem]", key: "name", label: "Nombre", type: "text" }, 
    { width: "w-[7rem]", key: "category", label: "Categoría", type: "select", options: categoryOptions },
    { width: "w-[5rem]", key: "fixedGoal", label: "Meta fija", type: "number", formatter: (v) => ParseNumberToFloat({ number: v }) },
    { width: "w-[10rem]", key: "validFrom", label: "Válida desde", type: "date" },
    { width: "w-[10rem]", key: "validTo", label: "Válida hasta", type: "date" },
    { key: "__actions", label: "Acciones", type: "actions" },
  ]

  const softwareCols = [
    { width: "w-[15rem]", key: "name", label: "Nombre", type: "text" }, 
    { width: "w-[7rem]", key: "category", label: "Categoría", type: "select", options: categoryOptions },
    { width: "w-[5rem]", key: "rangeMin", label: "Precio mín.", type: "number", formatter: (v) => ParseNumberToFloat({ number: v }) },
    { width: "w-[5rem]", key: "rangeMax", label: "Precio máx.", type: "number", formatter: (v) => ParseNumberToFloat({ number: v }) },
    { width: "w-[5rem]", key: "percentage", label: "% Comisión", type: "number", suffix: "%", min: 0, max: 100 },
    { width: "w-[5rem]", key: "fixedGoal", label: "Meta fija", type: "number", formatter: (v) => ParseNumberToFloat({ number: v }) },
    { width: "w-[5rem]", key: "fixedCommission", label: "Comisión fija", type: "number", formatter: (v) => ParseNumberToFloat({ number: v }) },
    { width: "w-[10rem]", key: "validFrom", label: "Válida desde", type: "date" },
    { width: "w-[10rem]", key: "validTo", label: "Válida hasta", type: "date" },
    { key: "__actions", label: "Acciones", type: "actions" },
  ]
  
  const webCols = [
    { width: "w-[15rem]", key: "name", label: "Nombre", type: "text" }, 
    { width: "w-[7rem]", key: "category", label: "Categoría", type: "select", options: categoryOptions },
    { width: "w-[5rem]", key: "rangeMin", label: "Precio mín.", type: "number", formatter: (v) => ParseNumberToFloat({ number: v }) },
    { width: "w-[5rem]", key: "rangeMax", label: "Precio máx.", type: "number", formatter: (v) => ParseNumberToFloat({ number: v }) },
    { width: "w-[10rem]", key: "validFrom", label: "Válida desde", type: "date" },
    { width: "w-[10rem]", key: "validTo", label: "Válida hasta", type: "date" },
    { key: "__actions", label: "Acciones", type: "actions" },
  ]

  const adsCols = [
    { width: "w-[15rem]", key: "name", label: "Nombre", type: "text" }, 
    { width: "w-[7rem]", key: "category", label: "Categoría", type: "select", options: categoryOptions },
    { width: "w-[5rem]", key: "months", label: "Meses", type: "select", options: monthsOptions },
    { width: "w-[7rem]", key: "plan", label: "Plan", type: "select", options: planOptions },
    { width: "w-[5rem]", key: "percentage", label: "% Comisión", type: "number", suffix: "%", min: 0, max: 100 },
    { key: "__actions", label: "Acciones", type: "actions" },
  ]

  const rulesByCategory = useMemo(() => ({
    ADS: comissionRules.filter(r => r.category === "ADS"),
    Web: comissionRules.filter(r => r.category === "Web"),
    Software: comissionRules.filter(r => r.category === "Software"),
    Individual: comissionRules.filter(r => r.category === "Individual"),
  }), [comissionRules]);

  const renderTable = (title, columns, rules) => (
    <div className="px-4 py-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold text-zinc-700">{title}</h3>
        <span className="text-xs text-gray-500">{rules.length} reglas</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="text-xs sticky top-0 text-gray-900 bg-gray-200 z-20">
            <tr className="text-gray-700 text-center text-xs font-bold">
              {columns.map((c) => (
                <th key={c.key} className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white z-20">
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rules.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="p-4 text-center text-gray-500">Sin datos</td>
              </tr>
            ) : (
              rules.map((rule, idx) => {
                const id = rule.id || rule._id;
                const isEditing = editingId === id;
                return (
                  <tr key={id || idx} className={`${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                    {columns.map((c) => {
                      if (c.type === "actions") {
                        return (
                          <td key={`${id}-actions`} className="p-2">
                            {isEditing ? (
                              <div className="flex items-center gap-2 justify-center">
                                <DinamicBoxButton content="Guardar" icon={<FaSave />} action={saveEdit} color="green" />
                                <DinamicBoxButton content="Cancelar" icon={<FaTimes />} action={cancelEdit} color="gray" />
                              </div>
                            ) : (
                              <div className="flex items-center gap-2 justify-center">
                                <EditButton content="Editar" action={() => startEdit(rule)} />
                                {/* <DeleteButton content="Eliminar" action={() => deleteRule(rule)} /> */}
                              </div>
                            )}
                          </td>
                        )
                      }

                      const value = rule[c.key];
                      return (
                        <td key={`${id}-${c.key}`} className="p-2 text-center">
                          {isEditing ? (
                            c.type === "date" ? (
                              <InputRowValue 
                                type="date"
                                title="" 
                                value={editForm[c.key]}
                                width={c.width}
                                setValue={(v) => setEditForm(s => ({ ...s, [c.key]: v }))} 
                              />
                            ) : c.type === "select" ? (
                              <InputRowValue 
                                title="" 
                                type="select" 
                                value={editForm[c.key]} 
                                width={c.width}
                                setValue={(v) => setEditForm(s => ({ ...s, [c.key]: v }))} 
                                options={c.options} 
                              />
                            ) : c.type === "number" ? (
                              <InputRowValue 
                                title="" 
                                type="number" 
                                min={c.min} 
                                max={c.max} 
                                value={editForm[c.key]} 
                                width={c.width}
                                setValue={(v) => setEditForm(s => ({ ...s, [c.key]: v }))} 
                              />
                            ) : (
                              <InputRowValue 
                                title="" 
                                type="text" 
                                value={editForm[c.key]} 
                                width={c.width}
                                setValue={(v) => setEditForm(s => ({ ...s, [c.key]: v }))} 
                              />
                            )
                          ) : (
                            <span className="text-gray-700">
                              {c.type === "date" ? (value ? String(value).slice(0,10) : '-') : (c.formatter ? c.formatter(value) : (value ?? '-'))}
                              {c.key === 'percentage' && value != null ? '%' : ''}
                            </span>
                          )}
                        </td>
                      )
                    })}
                  </tr>
                )
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  )

  return (
    <div className="flex flex-col h-screen w-full">

      {/* NavBar */}
      <div className="flex flex-row px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto overflow-y-hidden px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
          
          <div className="flex items-center gap-4 py-4">
            <FaMoneyBillTrendUp className="text-zinc-700 text-2xl" />
            <h2 className="text-2xl font-bold text-zinc-700">Reglas de comisiones</h2>
          </div>

          {/* <div className="flex flex-row gap-4 items-center justify-center">
            <Selector
              title="Categoría"
              value={categorySelected}
              setter={setCategorySelected}
              width="w-[8rem]"
              options={[{ label: "Todas", value: "" }, ...categoryOptions]}
              disabled={loading}
            />
          </div> */}

        </div>
      </div>

      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
          <LoadingScreen />
          ) : (
            comissionRules.length === 0 ? (
              <NoDataScreen />
            ) : (
              <div className="flex flex-col divide-y">
                {renderTable("Individual", individualCols, rulesByCategory.Individual)}
                {renderTable("Web", webCols, rulesByCategory.Web)}
                {renderTable("ADS", adsCols, rulesByCategory.ADS)}
                {renderTable("Software", softwareCols, rulesByCategory.Software)}
              </div>
            )
          )
        }
      </div>

    </div>
  )
}

export default ReglasComisiones;